import React, { useEffect, useState } from "react";
import { getOAuths } from "../utilities/genesysCloudUtils";
import "../App.css";
import { Loading } from "./Loading";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function OAuths({
  setPageCount,
  pageNumber,
  setPageNumber,
  setTabName,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [oAuths, setOAuths] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPageNumber(1);
    setTabName("oauths-tab");
    setIsVisible({ divisions: false, object: false, applyButton: false });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    generateOAuths();
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateOAuths = () => {
    setLoading(true);

    getOAuths()
      .then((data) => {
        setOAuths(data.entities);
        setPageCount(data.pageCount);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching OAuths:", error);
        setLoading(false);
      });
  };

  const allVisibleSelected = oAuths.length > 0 && oAuths.every((oAuth) => selectedExportRows[oAuth.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      loading={loading}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: oAuths })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(oAuths, checked)}
      rowCount={oAuths.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="OAuths"
    >
      {loading && <Loading text="Loading OAuths..." />}
      {!loading && oAuths ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th aria-label="Select rows" className="select-column"></th>
                <th className="count-column">Count</th>
                <th>OAuth Name</th>
                <th>Grant Type</th>
                <th>Redirect URI</th>
                <th>Client Id</th>
              </tr>
            </thead>
            <tbody>
              {oAuths.map((oAuth, index) => {
                return (
                  <tr key={oAuth.id}>
                    <td className="select-column">
                      <input
                        aria-label={`Select ${oAuth.name} for export`}
                        checked={Boolean(selectedExportRows[oAuth.id])}
                        onChange={(event) => onToggleExportRow(oAuth, event.target.checked)}
                        type="checkbox"
                      />
                    </td>
                    <th className="index count-column">
                      {pageNumber === 1
                        ? index + 1
                        : (pageNumber - 1) * 500 + index + 1}
                    </th>
                    <td>{oAuth.name}</td>
                    <td>{oAuth.authorizedGrantType}</td>
                    <td style={{ whiteSpace: 'pre-line' }}>
                      {Array.isArray(oAuth.registeredRedirectUri)
                        ? oAuth.registeredRedirectUri.join('\n')
                        : oAuth.registeredRedirectUri}
                    </td>
                    <td>
                      <kbd className="kbd">{oAuth.id}</kbd>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <h1>Loading...</h1>
      )}
    </CatalogTableSurface>
  );
}
